import { Grid, Skeleton } from '@mui/material';
import React from 'react';

// This is exactly the same as LineItemSkeleton for now, in the future it may be different
function AdGroupSkeleton() {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Skeleton sx={{ m: 2 }} variant="rectangular" width="25%" height="25" />
        <Skeleton sx={{ m: 2 }} variant="rectangular" width="95%" height="85vh" />
      </Grid>
    </Grid>
  );
}

export default AdGroupSkeleton;
